<template>
	<app-content class="h-panel">
		<Tabs :datas="tabDatas" v-model="selected" @change="change"></Tabs>
		<div class="padding-top padding-right text-right">
			<Button @click="showImport = true">导入</Button>
			<Button @click="exportData">导出</Button>
			<Button color="red" @click="showClear = true">清空</Button>
			<Button @click="openCashFlow">现金流期初</Button>
			<Button @click="trialBalance">试算平衡</Button>
		</div>
		<div class="h-panel-body padding">
			<table class="cus-table">
				<thead class="header">
				<tr v-if="!isUnit">
					<td width="150">科目编码</td>
					<td nowrap>科目名称</td>
					<td width="100" nowrap>余额方向</td>
					<td width="150">期初余额</td>
					<td width="150">借方累计</td>
					<td width="150">贷方累计</td>
					<td width="150">年初余额</td>
				</tr>
				<template v-else>
					<tr>
						<td width="150" rowspan="2">科目编码</td>
						<td rowspan="2" nowrap>科目名称</td>
						<td width="100" rowspan="2" nowrap>余额方向</td>
						<td width="70" rowspan="2" nowrap>单位</td>
						<td colspan="2">期初余额</td>
						<td colspan="2">借方累计</td>
						<td colspan="2">贷方累计</td>
						<td colspan="2">年初余额</td>
					</tr>
					<tr>
						<td width="150">数量</td>
						<td width="150">金额</td>
						<td width="150">数量</td>
						<td width="150">金额</td>
						<td width="150">数量</td>
						<td width="150">金额</td>
						<td width="150">数量</td>
						<td width="150">金额</td>
					</tr>
				</template>
				</thead>
				<tbody>
				<tr v-for="(item,i) in datas" :key="i">
					<td :style="{paddingLeft:(item.level!=1?(item.level-1)*20:10)+'px'}">{{item.code}}</td>
					<td nowrap>
						{{item.name}} <i @click="addDetails(item)" class="fa fa-plus text-hover" v-if="item.auxiliaryAccounting" v-tooltip content="点击+号<br/>添加辅助明细"></i>
					</td>
					<td class="text-center">{{item.balanceDirection}}</td>
					<td class="text-center" v-if="isUnit">{{item.unit}}</td>
					<td class="text-center" v-if="isUnit" :class="{'edit-hover':(!item._numEdit && item.leaf && !item.auxiliaryAccounting && item.unit)}">
						<template v-if="item.unit && item.leaf && !item.auxiliaryAccounting">
							<div class="editblock edit-block" v-if="!item._numEdit" @dblclick="showInput($event,item,'_numEdit',i)">{{item.num|numFormat}}</div>
							<NumberInput :id="'_numEdit'+i" v-width="130" v-if="item._numEdit" v-model="item.num" @change="balanceChange(item,'_numEdit')"/>
						</template>
						<template v-else>
							{{item.num|numFormat}}
						</template>
					</td>
					<td class="text-right" :class="{'edit-hover':(!item._edit && item.leaf && !item.auxiliaryAccounting)}">
						<template v-if="item.leaf && !item.auxiliaryAccounting">
							<div class="editblock balance-edit-block" :data-code="item.code" :data-num="item.beginBalance" v-if="!item._edit" @dblclick="showInput($event,item,'_edit',i)">{{item.beginBalance|numFormat}}</div>
							<NumberInput :id="'_edit'+i" v-width="130" v-if="item._edit" v-model="item.beginBalance" @change="balanceChange(item,'_edit')"/>
						</template>
						<template v-else>
							<span class="balance" :data-code="item.code" :data-index="i">{{item.beginBalance|numFormat}}</span>
						</template>
						<div class="foreign-line" v-if="item.leaf && !item.auxiliaryAccounting && item.currencyAccounting && item.currencyName">
							<span class="foreign-name">{{item.currencyName}}</span>
							<input type="text" class="foreign-input" v-model="item.originalAmount" @change="foreignChange(item)" placeholder="原币">
							<span class="foreign-x">×</span>
							<input type="text" class="foreign-input foreign-rate" v-model="item.exchangeRate" @change="foreignChange(item)" placeholder="汇率">
						</div>
					</td>
					<td class="text-center" v-if="isUnit" :class="{'edit-hover':(!item._cumulativeDebitNumEdit && item.leaf && !item.auxiliaryAccounting && item.unit)}">
						<template v-if="item.unit && item.leaf && !item.auxiliaryAccounting">
							<div class="editblock edit-block" v-if="!item._cumulativeDebitNumEdit" @dblclick="showInput($event,item,'_cumulativeDebitNumEdit',i)">{{item.cumulativeDebitNum|numFormat}}</div>
							<NumberInput :id="'_cumulativeDebitNumEdit'+i" v-width="130" v-if="item._cumulativeDebitNumEdit" v-model="item.cumulativeDebitNum" @change="balanceChange(item,'_cumulativeDebitNumEdit')"/>
						</template>
						<template v-else>
							{{item.cumulativeDebitNum|numFormat}}
						</template>
					</td>
					<td class="text-right" :class="{'edit-hover':(!item._cumulativeDebitEdit && item.leaf && !item.auxiliaryAccounting)}">
						<template v-if="item.leaf && !item.auxiliaryAccounting">
							<div class="editblock debit-edit-block" :data-code="item.code" :data-num="item.cumulativeDebit" v-if="!item._cumulativeDebitEdit" @dblclick="showInput($event,item,'_cumulativeDebitEdit',i)">{{item.cumulativeDebit|numFormat}}</div>
							<NumberInput :id="'_cumulativeDebitEdit'+i" v-width="130" v-if="item._cumulativeDebitEdit" v-model="item.cumulativeDebit" @change="balanceChange(item,'_cumulativeDebitEdit')"/>
						</template>
						<template v-else>
							<span class="debit" :data-code="item.code" :data-index="i">{{item.cumulativeDebit|numFormat}}</span>
						</template>
					</td>
					<td class="text-center" v-if="isUnit" :class="{'edit-hover':(!item._cumulativeCreditNumEdit && item.leaf && !item.auxiliaryAccounting && item.unit)}">
						<template v-if="item.unit && item.leaf && !item.auxiliaryAccounting">
							<div class="editblock edit-block" v-if="!item._cumulativeCreditNumEdit" @dblclick="showInput($event,item,'_cumulativeCreditNumEdit',i)">{{item.cumulativeCreditNum|numFormat}}</div>
							<NumberInput :id="'_cumulativeCreditNumEdit'+i" v-width="130" v-if="item._cumulativeCreditNumEdit" v-model="item.cumulativeCreditNum" @change="balanceChange(item,'_cumulativeCreditNumEdit')"/>
						</template>
						<template v-else>
							{{item.cumulativeCreditNum|numFormat}}
						</template>
					</td>
					<td class="text-right" :class="{'edit-hover':(!item._cumulativeCreditEdit && item.leaf && !item.auxiliaryAccounting)}">
						<template v-if="item.leaf && !item.auxiliaryAccounting">
							<div class="editblock credit-edit-block" :data-code="item.code" :data-num="item.cumulativeCredit" v-if="!item._cumulativeCreditEdit" @dblclick="showInput($event,item,'_cumulativeCreditEdit',i)">{{item.cumulativeCredit|numFormat}}</div>
							<NumberInput :id="'_cumulativeCreditEdit'+i" v-width="130" v-if="item._cumulativeCreditEdit" v-model="item.cumulativeCredit" @change="balanceChange(item,'_cumulativeCreditEdit')"/>
						</template>
						<template v-else>
							<span class="credit" :data-code="item.code" :data-index="i">{{item.cumulativeCredit|numFormat}}</span>
						</template>
					</td>
					<td class="text-center" v-if="isUnit">
						{{item.cumulativeCreditNum|numFormat}}
					</td>
					<td class="text-right">
						{{(item.beginBalance-(item.cumulativeDebit||0)+(item.cumulativeCredit||0))|numFormat}}
					</td>
				</tr>
				<tr v-if="!datas.length">
					<td colspan="8" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
		<Modal v-model="showModal" hasCloseIcon hasDivider>
			<div slot="header">期初试算结果</div>
			<Row class="result">
				<Cell :width="12" class="text-center" style="border-right: 1px solid #eeeeee">
					<div class="font-bold margin">期初余额</div>
					<div class="pic-body beginningBalance" :class="{left:beginningBalance.借<beginningBalance.贷,right:beginningBalance.借>beginningBalance.贷}">
						<span class="span1">{{beginningBalance.借|numFormat}}</span>
						<span class="span2">{{beginningBalance.借-beginningBalance.贷|numFormat}}</span>
						<span class="span3">{{beginningBalance.贷|numFormat}}</span>
						<div class="pic"></div>
					</div>
				</Cell>
				<Cell :width="12" class="text-center">
					<div class="font-bold margin">资产负债表期初</div>
					<div class="pic-body liabilities" :class="{left:liabilities.资产<liabilities.权益,right:liabilities.资产>liabilities.权益}">
						<span class="span1">{{liabilities.资产|numFormat}}</span>
						<span class="span2">{{liabilities.资产-liabilities.权益|numFormat}}</span>
						<span class="span3">{{liabilities.权益|numFormat}}</span>
						<div class="pic "></div>
					</div>
				</Cell>
			</Row>
		</Modal>
		<Modal v-model="showDetailModal" hasCloseIcon hasDivider>
			<div slot="header">增加明细</div>
			<Form v-width="400" :labelWidth="60" class="padding-right margin-top">
				<FormItem label="科目">
					<Select @change="subjectChange" v-model="auxiliary.subjectId" :datas="auxiliarys" :deletable="false" titleName="name" keyName="subjectId"></Select>
				</FormItem>
				<FormItem v-for="item in auxiliaryAccounting" :label="item.name" :key="item.id">
					<Select v-model="auxiliary.auxiliary[item.id]" :datas="auxiliaryAccountingData[auxiliary.subjectId]?auxiliaryAccountingData[auxiliary.subjectId][item.id]:[]" :deletable="false" titleName="name" keyName="id">
						<template slot-scope="{item}" slot="item">{{item.code}}-{{item.name}}</template>
					</Select>
				</FormItem>
			</Form>
			<div class="text-center margin-top">
				<Button color="green" @click="saveAuxiliary" :loading="loading">增加</Button>
				<Button @click="showDetailModal=false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="showImport" hasCloseIcon hasDivider>
			<div slot="header">财务期初余额导入</div>
			<div class="padding">
				<p>第一步：请点击下载Excel模板，并按照模板填写信息</p>
				<p class="margin-top"><a class="text-hover" @click="downloadTemplate">下载模板</a></p>
				<p class="margin-top">第二步：导入Excel模板文件</p>
				<p class="margin-top"><a class="text-hover" @click="chooseFile">{{ importFile ? importFile.name : '选择文件' }}</a></p>
				<input ref="fileInput" type="file" accept=".xlsx,.xls" style="display:none" @change="fileChange"/>
			</div>
			<div class="text-center margin-top">
				<Button color="green" :loading="loading" @click="doImport">导入</Button>
				<Button @click="showImport=false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="showClear" hasCloseIcon hasDivider>
			<div slot="header">清空期初数据</div>
			<div class="padding">
				<p>确定清空当前账套的全部期初数据吗？</p>
				<p class="text-gray">该操作将删除所有科目的期初余额、累计发生额及辅助核算期初明细，且不可恢复。</p>
			</div>
			<div class="text-center margin-top">
				<Button color="red" :loading="loading" @click="doClear">确定清空</Button>
				<Button @click="showClear=false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="showCashFlow" hasCloseIcon hasDivider width="860">
			<div slot="header">现金流期初</div>
			<div style="max-height:520px;overflow:auto" class="padding">
				<table class="cus-table">
					<thead class="header">
					<tr>
						<td>名称</td>
						<td width="80">行号</td>
						<td width="180">本年累计金额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(row,i) in cashFlowRows" :key="row.templateItemsId">
						<td :style="{paddingLeft:'10px'}" :class="{'font-bold':row._section}">{{row.title}}</td>
						<td class="text-center">{{row.lineNum}}</td>
						<td>
							<template v-if="row._section">{{row.amount|numFormat}}</template>
							<NumberInput v-else v-model="row.amount" v-width="160"/>
						</td>
					</tr>
					<tr v-if="!cashFlowRows.length">
						<td colspan="3" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="text-center margin-top">
				<Button color="blue" :loading="cashFlowLoading" @click="saveCashFlow">保存</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import {mapState} from 'vuex';
	import jQuery from 'jquery';

	const emptyForm = {
		"id": "0",
		"code": "",
		"name": "",
		"mnemonicCode": "",
		"balanceDirection": "",
		"status": "0",
		"parentId": "0"
	};

	export default {
		name: "Initial",
		data() {
			return {
				tabDatas: [
					{
						title: '资产',
						key: 'CodeAssets'
					}, {
						title: '负债',
						key: 'CodeLiabilities'
					}, {
						title: '权益',
						key: 'CodeInterest'
					}, {
						title: '成本',
						key: 'CodeCost'
					}, {
						title: '损益',
						key: 'CodeLoss'
					}],
				type: '资产',
				datas: [],
				form: Object.assign({}, emptyForm),
				showForm: false,
				showDetailModal: false,
				selected: 'CodeAssets',
				showModal: false,
				loading: false,
				temps: {},
				auxiliary: {subjectId: "", auxiliary: {}},
				auxiliaryAccounting: [],
				auxiliaryAccountingData: {},
				beginningBalance: {借: 0, 贷: 0},
				liabilities: {权益: 0, 资产: 0},
				showImport: false,
				importFile: null,
				showClear: false,
				showCashFlow: false,
				cashFlowRows: [],
				cashFlowLoading: false,
				currencyDatas: [],
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			isUnit() {
				return this.datas.filter(value => value.unit).length > 0;
			},
			auxiliarys() {
				return this.datas.filter(value => value.auxiliaryAccounting)
			}
		},
		watch: {
			type() {
				this.loadList();
			}
		},
		methods: {
			showInput(e, item, type, i) {
				this.$set(item, type, true);
				this.$nextTick(() => {
					jQuery('.h-input', '#' + type + i).focus().select()
				});
			},
			addDetails(item) {
				this.auxiliary.subjectId = item.subjectId;
				this.subjectChange(item);
				this.showDetailModal = true;
			},
			addTemp(data) {
				this.temps[data.id] = data;
				return data.id;
			},
			loadList() {
				this.loading = true;
				this.$api.setting.initialBalance.list({type: this.type}).then(({data}) => {
					this.datas = (data || []).map(item => this.enrichForeign(item));
					this.loading = false;

					this.$nextTick(this.calParent);
				})
			},
			enrichForeign(item) {
				if (!item.currencyAccounting || !item.leaf) {
					return item;
				}
				let ids = [];
				try {
					ids = JSON.parse(item.currencyAccounting).map(v => Number(v));
				} catch (e) {
					return item;
				}
				const cur = this.currencyDatas.find(c => ids.includes(c.id));
				if (cur) {
					if (!item.currencyId) {
						item.currencyId = cur.id;
						item.currencyName = cur.name;
					}
					if (item.exchangeRate == null) {
						item.exchangeRate = cur.exchangeRate || 1;
					}
				}
				return item;
			},
			foreignChange(item) {
				const original = Number(item.originalAmount);
				const rate = Number(item.exchangeRate);
				if (isNaN(original) || isNaN(rate) || rate <= 0) {
					return;
				}
				item.beginBalance = Math.round(original * rate * 100) / 100;
				this.balanceChange(item, '_fx');
			},
			loadCurrencies() {
				return this.$api.setting.currency.list().then(({data}) => {
					this.currencyDatas = data || [];
				});
			},
			calParent() {
				let cals = {'balance': 'beginBalance', 'debit': 'cumulativeDebit', 'credit': 'cumulativeCredit'};
				Object.keys(cals).forEach(key => {
					jQuery(`span.${key}`).each((i, item) => {
						let {code, index} = item.dataset;
						let total = 0;
						jQuery(`.${key}-edit-block[data-code^=${code}]`).each((i, numItem) => {
							if (numItem.dataset.num) {
								total += Number(numItem.dataset.num)
							}
						});
						this.datas[index][cals[key]] = total;
					});
				});

				this.datas = Array.from(this.datas);
			},
			change(data) {
				this.type = data.title;
			},
			balanceChange(balance, target) {
				let params = {
					summary: "期初",
					subjectName: `${balance.code}-${balance.name}`,
					subjectCode: balance.code,
					subjectId: balance.subjectId,
					accountSetsId: balance.accountSetsId,
					cumulativeCredit: balance.cumulativeCredit,
					cumulativeDebit: balance.cumulativeDebit,
					cumulativeDebitNum: balance.cumulativeDebitNum,
					cumulativeCreditNum: balance.cumulativeCreditNum,
					num: balance.num,
					currencyId: balance.currencyId,
					currencyName: balance.currencyName,
					exchangeRate: balance.exchangeRate,
					originalAmount: balance.originalAmount
				};

				if (balance.balanceDirection === '借') {
					params.debitAmount = balance.beginBalance;
				} else {
					params.creditAmount = balance.beginBalance;
				}
				this.$api.setting.initialBalance.save(params).then(({data}) => {
					this.$set(balance, target, false);
					this.$nextTick(this.calParent);
				});
			},
			trialBalance() {
				this.$api.setting.initialBalance.trialBalance().then(({data}) => {
					this.showModal = true;
					this.beginningBalance = Object.assign(this.beginningBalance, data.beginningBalance);
					this.liabilities = Object.assign(this.liabilities, data.liabilities);
				});
			},
			subjectChange(subject) {
				this.auxiliaryAccounting = JSON.parse(subject.auxiliaryAccounting);
				this.loadAuxiliaryAccountingData(subject);
			},
			loadAuxiliaryAccountingData(subject) {
				if (!this.auxiliaryAccountingData[subject.subjectId]) {
					this.$api.setting.accountingCategoryDetails.loadAuxiliaryAccountingData(this.auxiliaryAccounting).then(({data}) => {
						this.$set(this.auxiliaryAccountingData, subject.subjectId, data);
					});
				}
			},
			saveAuxiliary() {
				if (this.auxiliary.subjectId && Object.keys(this.auxiliary.auxiliary).length === this.auxiliaryAccounting.length) {
					this.loading = true;
					this.$api.setting.initialBalance.saveAuxiliary(this.auxiliary).then(({data}) => {
						this.loadList();
						this.showDetailModal = false;
					}).finally(() => {
						this.loading = false;
					});
				}
			},
			exportData() {
				window.open('/api/initial-balance/export');
			},
			downloadTemplate() {
				window.open('/api/initial-balance/template');
			},
			chooseFile() {
				this.$refs.fileInput.click();
			},
			fileChange(e) {
				let files = e.target.files;
				this.importFile = files && files.length ? files[0] : null;
			},
			doImport() {
				if (!this.importFile) {
					HeyUI.$Message.error('请先选择要导入的Excel文件');
					return;
				}
				this.loading = true;
				let formData = new FormData();
				formData.append('file', this.importFile);
				this.$api.setting.initialBalance.importData(formData).then(({data, msg}) => {
					HeyUI.$Message.success(msg || '导入成功');
					this.showImport = false;
					this.importFile = null;
					this.$refs.fileInput.value = '';
					this.loadList();
				}).finally(() => {
					this.loading = false;
				});
			},
			doClear() {
				this.loading = true;
				this.$api.setting.initialBalance.clear().then(() => {
					HeyUI.$Message.success('期初数据已清空');
					this.showClear = false;
					this.loadList();
				}).finally(() => {
					this.loading = false;
				});
			},
			openCashFlow() {
				this.cashFlowRows = [];
				this.showCashFlow = true;
				this.$api.setting.initialBalance.cashFlow().then(({data}) => {
					this.cashFlowRows = (data || []).map(row => Object.assign(row, {_section: /^[一二三四五六七八九十]+、/.test(row.title || '')}));
				});
			},
			saveCashFlow() {
				this.cashFlowLoading = true;
				this.$api.setting.initialBalance.saveCashFlow(this.cashFlowRows.filter(row => !row._section).map(row => ({
					templateItemsId: row.templateItemsId,
					amount: row.amount === '' || row.amount === null ? null : Number(row.amount)
				}))).then(() => {
					HeyUI.$Message.success('现金流期初已保存');
					this.showCashFlow = false;
				}).finally(() => {
					this.cashFlowLoading = false;
				});
			}
		},
		mounted() {
			if (this.currentAccountSets.accountingStandards !== 0) {
				this.tabDatas = [{
					title: '资产',
					key: 'CodeAssets'
				}, {
					title: '负债',
					key: 'CodeLiabilities'
				}, {
					title: '共同',
					key: 'Common'
				}, {
					title: '权益',
					key: 'CodeInterest'
				}, {
					title: '成本',
					key: 'CodeCost'
				}, {
					title: '损益',
					key: 'CodeLoss'
				}];
			}
			this.loadCurrencies().then(() => this.loadList());
		}
	};
</script>
<style lang="less" scoped>
	.foreign-line {
		display: flex;
		align-items: center;
		margin-top: 2px;

		.foreign-name {
			color: #888;
			font-size: 12px;
			margin-right: 3px;
			white-space: nowrap;
		}

		.foreign-input {
			width: 56px;
			height: 22px;
			border: 1px solid #e2e2e2;
			border-radius: 2px;
			padding: 0 3px;
			font-size: 12px;
			text-align: right;
		}

		.foreign-rate {
			width: 44px;
		}

		.foreign-x {
			margin: 0 2px;
			color: #888;
			font-size: 12px;
		}
	}

	.result {
		width: 500px;
		height: 250px;

		.pic {
			width: 238px;
			height: 120px;
			background-image: url("../../assets/settings.png");
			background-repeat: no-repeat;
			margin: 20px auto;
		}


		.pic-body {
			margin-top: 50px;
			position: relative;

			&.beginningBalance {
				.pic {
					background-position: -160px 0px;
				}

				span {
					position: absolute;
				}

				.span1 {
					top: 0;
					left: 22px;
				}

				.span2 {
					top: 50px;
					left: 0;
					width: 100%;
				}

				.span3 {
					top: 0;
					right: 10px;
				}

				&.right {
					.pic {
						height: 130px;
						background-position: -160px -132px;
					}

					.span1 {
						top: 25px;
					}

					.span3 {
						top: -25px;
					}
				}

				&.left {
					.pic {
						height: 130px;
						background-position: -160px -272px;
					}

					.span1 {
						top: -25px;
					}

					.span3 {
						top: 25px;
					}
				}
			}

			&.liabilities {
				.pic {
					background-position: -420px 5px;
				}

				span {
					position: absolute;
				}

				.span1 {
					top: 0;
					left: 22px;
				}

				.span2 {
					top: 50px;
					left: 0;
					width: 100%;
				}

				.span3 {
					top: 0;
					right: 10px;
				}

				&.right {
					.pic {
						height: 130px;
						background-position: -420px -132px;
					}

					.span1 {
						top: 25px;
					}

					.span3 {
						top: -25px;
					}
				}

				&.left {
					.pic {
						height: 130px;
						background-position: -420px -272px;
					}

					.span1 {
						top: -25px;
					}

					.span3 {
						top: 25px;
					}
				}
			}
		}
	}

	.editblock {
		width: 100%;
		height: 100%;
		line-height: 33px;
	}

	.edit-hover:hover {
		cursor: pointer;
		background-color: @gray2-color;
	}
</style>
